module.exports = __webpack_public_path__ + "cb58c20a1b83cf14f56ba031c014e297.wav";